import { motion } from "framer-motion";

export default function LegalLayout({ title, kicker, lastUpdated, children, testId }) {
    return (
        <section className="pt-32 lg:pt-40 pb-24" data-testid={testId}>
            <div className="max-w-3xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                >
                    {kicker && (
                        <p className="text-xs text-coway uppercase tracking-[0.3em] font-semibold mb-5">
                            {kicker}
                        </p>
                    )}
                    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-slate-900">
                        {title}
                    </h1>
                    {lastUpdated && (
                        <p className="mt-6 text-sm text-slate-500">
                            Dernière mise à jour : {lastUpdated}
                        </p>
                    )}
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                    className="mt-12 prose prose-slate prose-headings:font-display prose-headings:tracking-tight prose-headings:text-slate-900 prose-p:text-slate-700 prose-li:text-slate-700 prose-a:text-coway prose-a:no-underline hover:prose-a:underline prose-strong:text-slate-900 max-w-none [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-12 [&_h2]:mb-4 [&_h3]:text-xl [&_h3]:font-bold [&_h3]:mt-8 [&_h3]:mb-3 [&_p]:leading-relaxed [&_p]:text-base [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-2"
                >
                    {children}
                </motion.div>
            </div>
        </section>
    );
}
